import { useQuery } from '@tanstack/react-query';

import { useProject } from '../../projects/context';
import { useProjectApi } from '../../projects/useProjectApi';
import { LeadContactEdit } from './LeadContactEdit';

// LeadContactEditById: „Daten bearbeiten“ dort, wo nur die Lead-ID bekannt ist (Terminseite) – lädt den Lead (Recht lead.edit).
export function LeadContactEditById({ leadId }: { leadId: string }) {
  const { project, can } = useProject();
  const papi = useProjectApi();
  const lead = useQuery({
    queryKey: ['projects', project.id, 'lead', leadId],
    queryFn: ({ signal }) => papi.lead(leadId, signal),
    enabled: can('lead.edit'),
  });
  if (!can('lead.edit') || !lead.data) return null;
  return <LeadContactEdit lead={lead.data} />;
}
